module.exports = __webpack_public_path__ + "img/badge-most-proposals-keyvue-blue.999fd769.png";